import _toConsumableArray from "C:\\xampp\\htdocs\\beezer\\Platform\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _inherits from "C:\\xampp\\htdocs\\beezer\\Platform\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "C:\\xampp\\htdocs\\beezer\\Platform\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\xampp\\htdocs\\beezer\\Platform\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _slicedToArray from "C:\\xampp\\htdocs\\beezer\\Platform\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "C:\\xampp\\htdocs\\beezer\\Platform\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\xampp\\htdocs\\beezer\\Platform\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { Parser, NodeProp, NodeSet, NodeType, DefaultBufferLength, Tree, IterMode } from '@lezer/common'; /// A parse stack. These are used internally by the parser to track
/// parsing progress. They also provide some properties and methods
/// that external code such as a tokenizer can use to get information
/// about the parse state.

var Stack = /*#__PURE__*/function () {
  /// @internal
  function Stack( /// The parse that this stack is part of @internal
  p, /// Holds state, input pos, buffer index triplets for all but the
  /// top state @internal
  stack, /// The current parse state @internal
  state, // The position at which the next reduce should take place. This
  // can be less than `this.pos` when skipped expressions have been
  // added to the stack (which should be moved outside of the next
  // reduction)
  /// @internal
  reducePos, /// The input position up to which this stack has parsed.
  pos, /// The dynamic score of the stack, including dynamic precedence
  /// and error-recovery penalties
  /// @internal
  score, // The output buffer. Holds (type, start, end, size) quads
  // representing nodes created by the parser, where `size` is
  // amount of buffer array entries covered by this node.
  /// @internal
  buffer, // The base offset of the buffer. When stacks are split, the split
  // instance shared the buffer history with its parent up to
  // `bufferBase`, which is the absolute offset (including the
  // offset of previous splits) into the buffer at which this stack
  // starts writing.
  /// @internal
  bufferBase, /// @internal
  curContext) {
    var lookAhead = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 0;
    var // A parent stack from which this was split off, if any. This is
    // set up so that it always points to a stack that has some
    // additional buffer content, never to a stack with an equal
    // `bufferBase`.
    /// @internal
    parent = arguments.length > 10 ? arguments[10] : undefined;

    _classCallCheck(this, Stack);

    this.p = p;
    this.stack = stack;
    this.state = state;
    this.reducePos = reducePos;
    this.pos = pos;
    this.score = score;
    this.buffer = buffer;
    this.bufferBase = bufferBase;
    this.curContext = curContext;
    this.lookAhead = lookAhead;
    this.parent = parent;
  } /// @internal


  _createClass(Stack, [{
    key: "toString",
    value: function toString() {
      return "[".concat(this.stack.filter(function (_, i) {
        return i % 3 == 0;
      }).concat(this.state), "]@").concat(this.pos).concat(this.score ? "!" + this.score : "");
    } // Start an empty stack
    /// @internal

  }, {
    key: "context",
    get: /// The stack's current [context](#lr.ContextTracker) value, if
    /// any. Its type will depend on the context tracker's type
    /// parameter, or it will be `null` if there is no context
    /// tracker.
    function get() {
      return this.curContext ? this.curContext.context : null;
    } // Push a state onto the stack, tracking its start position as well
    // as the buffer base at that point.
    /// @internal

  }, {
    key: "pushState",
    value: function pushState(state, start) {
      this.stack.push(this.state, start, this.bufferBase + this.buffer.length);
      this.state = state;
    } // Apply a reduce action
    /// @internal

  }, {
    key: "reduce",
    value: function reduce(action) {
      var _a;

      var depth = action >> 19
      /* Action.ReduceDepthShift */
      ,
          type = action & 65535
      /* Action.ValueMask */
      ;
      var parser = this.p.parser;
      var dPrec = parser.dynamicPrecedence(type);
      if (dPrec) this.score += dPrec;

      if (depth == 0) {
        this.pushState(parser.getGoto(this.state, type, true), this.reducePos); // Zero-depth reductions are a special case—they add stuff to
        // the stack without popping anything off.

        if (type < parser.minRepeatTerm) this.storeNode(type, this.reducePos, this.reducePos, 4, true);
        this.reduceContext(type, this.reducePos);
        return;
      } // Find the base index into `this.stack`, content after which will
      // be dropped. Note that with `StayFlag` reductions we need to
      // consume two extra frames (the dummy parent node for the skipped
      // expression and the state that we'll be staying in, which should
      // be moved to `this.state`).


      var base = this.stack.length - (depth - 1) * 3 - (action & 262144
      /* Action.StayFlag */
      ? 6 : 0);
      var start = base ? this.stack[base - 2] : this.p.ranges[0].from,
          size = this.reducePos - start; // This is a kludge to try and detect overly deep left-associative
      // trees, which will not increase the parse stack depth and thus
      // won't be caught by the regular stack-depth limit check.

      if (size >= 2000
      /* Recover.MinBigReduction */
      && !((_a = this.p.parser.nodeSet.types[type]) === null || _a === void 0 ? void 0 : _a.isAnonymous)) {
        if (start == this.p.lastBigReductionStart) {
          this.p.bigReductionCount++;
          this.p.lastBigReductionSize = size;
        } else if (this.p.lastBigReductionSize < size) {
          this.p.bigReductionCount = 1;
          this.p.lastBigReductionStart = start;
          this.p.lastBigReductionSize = size;
        }
      }

      var bufferBase = base ? this.stack[base - 1] : 0,
          count = this.bufferBase + this.buffer.length - bufferBase; // Store normal terms or `R -> R R` repeat reductions

      if (type < parser.minRepeatTerm || action & 131072
      /* Action.RepeatFlag */
      ) {
        var pos = parser.stateFlag(this.state, 1
        /* StateFlag.Skipped */
        ) ? this.pos : this.reducePos;
        this.storeNode(type, start, pos, count + 4, true);
      }

      if (action & 262144
      /* Action.StayFlag */
      ) {
        this.state = this.stack[base];
      } else {
        var baseStateID = this.stack[base - 3];
        this.state = parser.getGoto(baseStateID, type, true);
      }

      while (this.stack.length > base) {
        this.stack.pop();
      }

      this.reduceContext(type, start);
    } // Shift a value into the buffer
    /// @internal

  }, {
    key: "storeNode",
    value: function storeNode(term, start, end) {
      var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 4;
      var isReduce = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      if (term == 0
      /* Term.Err */
      && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
        // Try to omit/merge adjacent error nodes
        var cur = this,
            top = this.buffer.length;

        if (top == 0 && cur.parent) {
          top = cur.bufferBase - cur.parent.bufferBase;
          cur = cur.parent;
        }

        if (top > 0 && cur.buffer[top - 4] == 0
        /* Term.Err */
        && cur.buffer[top - 1] > -1) {
          if (start == end) return;

          if (cur.buffer[top - 2] >= start) {
            cur.buffer[top - 2] = end;
            return;
          }
        }
      }

      if (!isReduce || this.pos == end) {
        // Simple case, just append
        this.buffer.push(term, start, end, size);
      } else {
        // There may be skipped nodes that have to be moved forward
        var index = this.buffer.length;
        if (index > 0 && this.buffer[index - 4] != 0
        /* Term.Err */
        ) while (index > 0 && this.buffer[index - 2] > end) {
          // Move this record forward
          this.buffer[index] = this.buffer[index - 4];
          this.buffer[index + 1] = this.buffer[index - 3];
          this.buffer[index + 2] = this.buffer[index - 2];
          this.buffer[index + 3] = this.buffer[index - 1];
          index -= 4;
          if (size > 4) size -= 4;
        }
        this.buffer[index] = term;
        this.buffer[index + 1] = start;
        this.buffer[index + 2] = end;
        this.buffer[index + 3] = size;
      }
    } // Apply a shift action
    /// @internal

  }, {
    key: "shift",
    value: function shift(action, next, nextEnd) {
      var start = this.pos;

      if (action & 131072
      /* Action.GotoFlag */
      ) {
        this.pushState(action & 65535
        /* Action.ValueMask */
        , this.pos);
      } else if ((action & 262144
      /* Action.StayFlag */
      ) == 0) {
        // Regular shift
        var nextState = action,
            parser = this.p.parser;

        if (nextEnd > this.pos || next <= parser.maxNode) {
          this.pos = nextEnd;
          if (!parser.stateFlag(nextState, 1
          /* StateFlag.Skipped */
          )) this.reducePos = nextEnd;
        }

        this.pushState(nextState, start);
        this.shiftContext(next, start);
        if (next <= parser.maxNode) this.buffer.push(next, start, nextEnd, 4);
      } else {
        // Shift-and-stay, which means this is a skipped token
        this.pos = nextEnd;
        this.shiftContext(next, start);
        if (next <= this.p.parser.maxNode) this.buffer.push(next, start, nextEnd, 4);
      }
    } // Apply an action
    /// @internal

  }, {
    key: "apply",
    value: function apply(action, next, nextEnd) {
      if (action & 65536
      /* Action.ReduceFlag */
      ) this.reduce(action);else this.shift(action, next, nextEnd);
    } // Add a prebuilt (reused) node into the buffer.
    /// @internal

  }, {
    key: "useNode",
    value: function useNode(value, next) {
      var index = this.p.reused.length - 1;

      if (index < 0 || this.p.reused[index] != value) {
        this.p.reused.push(value);
        index++;
      }

      var start = this.pos;
      this.reducePos = this.pos = start + value.length;
      this.pushState(next, start);
      this.buffer.push(index, start, this.reducePos, -1
      /* size == -1 means this is a reused value */
      );
      if (this.curContext) this.updateContext(this.curContext.tracker.reuse(this.curContext.context, value, this, this.p.stream.reset(this.pos - value.length)));
    } // Split the stack. Due to the buffer sharing and the fact
    // that `this.stack` tends to stay quite shallow, this isn't very
    // expensive.
    /// @internal

  }, {
    key: "split",
    value: function split() {
      var parent = this;
      var off = parent.buffer.length; // Because the top of the buffer (after this.pos) may be mutated
      // to reorder reductions and skipped tokens, and shared buffers
      // should be immutable, this copies any outstanding skipped tokens
      // to the new buffer, and puts the base pointer before them.

      while (off > 0 && parent.buffer[off - 2] > parent.reducePos) {
        off -= 4;
      }

      var buffer = parent.buffer.slice(off),
          base = parent.bufferBase + off; // Make sure parent points to an actual parent with content, if there is such a parent.

      while (parent && base == parent.bufferBase) {
        parent = parent.parent;
      }

      return new Stack(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, buffer, base, this.curContext, this.lookAhead, parent);
    } // Try to recover from an error by 'deleting' (ignoring) one token.
    /// @internal

  }, {
    key: "recoverByDelete",
    value: function recoverByDelete(next, nextEnd) {
      var isNode = next <= this.p.parser.maxNode;
      if (isNode) this.storeNode(next, this.pos, nextEnd, 4);
      this.storeNode(0
      /* Term.Err */
      , this.pos, nextEnd, isNode ? 8 : 4);
      this.pos = this.reducePos = nextEnd;
      this.score -= 190
      /* Recover.Delete */
      ;
    } /// Check if the given term would be able to be shifted (optionally
    /// after some reductions) on this stack. This can be useful for
    /// external tokenizers that want to make sure they only provide a
    /// given token when it applies.

  }, {
    key: "canShift",
    value: function canShift(term) {
      for (var sim = new SimulatedStack(this);;) {
        var action = this.p.parser.stateSlot(sim.state, 4
        /* ParseState.DefaultReduce */
        ) || this.p.parser.hasAction(sim.state, term);
        if (action == 0) return false;
        if ((action & 65536
        /* Action.ReduceFlag */
        ) == 0) return true;
        sim.reduce(action);
      }
    } // Apply up to Recover.MaxNext recovery actions that conceptually
    // inserts some missing token or rule.
    /// @internal

  }, {
    key: "recoverByInsert",
    value: function recoverByInsert(next) {
      if (this.stack.length >= 300
      /* Recover.MaxInsertStackDepth */
      ) return [];
      var nextStates = this.p.parser.nextStates(this.state);

      if (nextStates.length > 4
      /* Recover.MaxNext */
      << 1 || this.stack.length >= 120
      /* Recover.DampenInsertStackDepth */
      ) {
        var best = [];

        for (var i = 0, s; i < nextStates.length; i += 2) {
          if ((s = nextStates[i + 1]) != this.state && this.p.parser.hasAction(s, next)) best.push(nextStates[i], s);
        }

        if (this.stack.length < 120
        /* Recover.DampenInsertStackDepth */
        ) {
          var _loop = function _loop(_i) {
            var s = nextStates[_i + 1];
            if (!best.some(function (v, i) {
              return i & 1 && v == s;
            })) best.push(nextStates[_i], s);
          };

          for (var _i = 0; best.length < 4
          /* Recover.MaxNext */
          << 1 && _i < nextStates.length; _i += 2) {
            _loop(_i);
          }
        }

        nextStates = best;
      }

      var result = [];

      for (var _i2 = 0; _i2 < nextStates.length && result.length < 4
      /* Recover.MaxNext */
      ; _i2 += 2) {
        var _s = nextStates[_i2 + 1];
        if (_s == this.state) continue;
        var stack = this.split();
        stack.pushState(_s, this.pos);
        stack.storeNode(0
        /* Term.Err */
        , stack.pos, stack.pos, 4, true);
        stack.shiftContext(nextStates[_i2], this.pos);
        stack.score -= 200
        /* Recover.Insert */
        ;
        result.push(stack);
      }

      return result;
    } // Force a reduce, if possible. Return false if that can't
    // be done.
    /// @internal

  }, {
    key: "forceReduce",
    value: function forceReduce() {
      var reduce = this.p.parser.stateSlot(this.state, 5
      /* ParseState.ForcedReduce */
      );
      if ((reduce & 65536
      /* Action.ReduceFlag */
      ) == 0) return false;
      var parser = this.p.parser;

      if (!parser.validAction(this.state, reduce)) {
        var depth = reduce >> 19
        /* Action.ReduceDepthShift */
        ,
            term = reduce & 65535
        /* Action.ValueMask */
        ;
        var target = this.stack.length - depth * 3;
        if (target < 0 || parser.getGoto(this.stack[target], term, false) < 0) return false;
        this.storeNode(0
        /* Term.Err */
        , this.reducePos, this.reducePos, 4, true);
        this.score -= 100
        /* Recover.Reduce */
        ;
      }

      this.reducePos = this.pos;
      this.reduce(reduce);
      return true;
    } /// @internal

  }, {
    key: "forceAll",
    value: function forceAll() {
      while (!this.p.parser.stateFlag(this.state, 2
      /* StateFlag.Accepting */
      )) {
        if (!this.forceReduce()) {
          this.storeNode(0
          /* Term.Err */
          , this.pos, this.pos, 4, true);
          break;
        }
      }

      return this;
    } /// Check whether this state has no further actions (assumed to be a direct descendant of the
    /// top state, since any other states must be able to continue
    /// somehow). @internal

  }, {
    key: "deadEnd",
    get: function get() {
      if (this.stack.length != 3) return false;
      var parser = this.p.parser;
      return parser.data[parser.stateSlot(this.state, 1
      /* ParseState.Actions */
      )] == 65535
      /* Seq.End */
      && !parser.stateSlot(this.state, 4
      /* ParseState.DefaultReduce */
      );
    } /// Restart the stack (put it back in its start state). Only safe
    /// when this.stack.length == 3 (state is directly below the top
    /// state). @internal

  }, {
    key: "restart",
    value: function restart() {
      this.state = this.stack[0];
      this.stack.length = 0;
    } /// @internal

  }, {
    key: "sameState",
    value: function sameState(other) {
      if (this.state != other.state || this.stack.length != other.stack.length) return false;

      for (var i = 0; i < this.stack.length; i += 3) {
        if (this.stack[i] != other.stack[i]) return false;
      }

      return true;
    } /// Get the parser used by this stack.

  }, {
    key: "parser",
    get: function get() {
      return this.p.parser;
    } /// Test whether a given dialect (by numeric ID, as exported from
    /// the terms file) is enabled.

  }, {
    key: "dialectEnabled",
    value: function dialectEnabled(dialectID) {
      return this.p.parser.dialect.flags[dialectID];
    }
  }, {
    key: "shiftContext",
    value: function shiftContext(term, start) {
      if (this.curContext) this.updateContext(this.curContext.tracker.shift(this.curContext.context, term, this, this.p.stream.reset(start)));
    }
  }, {
    key: "reduceContext",
    value: function reduceContext(term, start) {
      if (this.curContext) this.updateContext(this.curContext.tracker.reduce(this.curContext.context, term, this, this.p.stream.reset(start)));
    } /// @internal

  }, {
    key: "emitContext",
    value: function emitContext() {
      var last = this.buffer.length - 1;
      if (last < 0 || this.buffer[last] != -3) this.buffer.push(this.curContext.hash, this.reducePos, this.reducePos, -3);
    } /// @internal

  }, {
    key: "emitLookAhead",
    value: function emitLookAhead() {
      var last = this.buffer.length - 1;
      if (last < 0 || this.buffer[last] != -4) this.buffer.push(this.lookAhead, this.reducePos, this.reducePos, -4);
    }
  }, {
    key: "updateContext",
    value: function updateContext(context) {
      if (context != this.curContext.context) {
        var newCx = new StackContext(this.curContext.tracker, context);
        if (newCx.hash != this.curContext.hash) this.emitContext();
        this.curContext = newCx;
      }
    } /// @internal

  }, {
    key: "setLookAhead",
    value: function setLookAhead(lookAhead) {
      if (lookAhead > this.lookAhead) {
        this.emitLookAhead();
        this.lookAhead = lookAhead;
      }
    } /// @internal

  }, {
    key: "close",
    value: function close() {
      if (this.curContext && this.curContext.tracker.strict) this.emitContext();
      if (this.lookAhead > 0) this.emitLookAhead();
    }
  }], [{
    key: "start",
    value: function start(p, state) {
      var pos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var cx = p.parser.context;
      return new Stack(p, [], state, pos, pos, 0, [], 0, cx ? new StackContext(cx, cx.start) : null, 0, null);
    }
  }]);

  return Stack;
}();

var StackContext = /*#__PURE__*/_createClass(function StackContext(tracker, context) {
  _classCallCheck(this, StackContext);

  this.tracker = tracker;
  this.context = context;
  this.hash = tracker.strict ? tracker.hash(context) : 0;
});

var Recover;

(function (Recover) {
  Recover[Recover["Insert"] = 200] = "Insert";
  Recover[Recover["Delete"] = 190] = "Delete";
  Recover[Recover["Reduce"] = 100] = "Reduce";
  Recover[Recover["MaxNext"] = 4] = "MaxNext";
  Recover[Recover["MaxInsertStackDepth"] = 300] = "MaxInsertStackDepth";
  Recover[Recover["DampenInsertStackDepth"] = 120] = "DampenInsertStackDepth";
  Recover[Recover["MinBigReduction"] = 2000] = "MinBigReduction";
})(Recover || (Recover = {})); // Used to cheaply run some reductions to scan ahead without mutating
// an entire stack


var SimulatedStack = /*#__PURE__*/function () {
  function SimulatedStack(start) {
    _classCallCheck(this, SimulatedStack);

    this.start = start;
    this.state = start.state;
    this.stack = start.stack;
    this.base = this.stack.length;
  }

  _createClass(SimulatedStack, [{
    key: "reduce",
    value: function reduce(action) {
      var term = action & 65535
      /* Action.ValueMask */
      ,
          depth = action >> 19
      /* Action.ReduceDepthShift */
      ;

      if (depth == 0) {
        if (this.stack == this.start.stack) this.stack = this.stack.slice();
        this.stack.push(this.state, 0, 0);
        this.base += 3;
      } else {
        this.base -= (depth - 1) * 3;
      }

      var goto = this.start.p.parser.getGoto(this.stack[this.base - 3], term, true);
      this.state = goto;
    }
  }]);

  return SimulatedStack;
}(); // This is given to `Tree.build` to build a buffer, and encapsulates
// the parent-stack-walking necessary to read the nodes.


var StackBufferCursor = /*#__PURE__*/function () {
  function StackBufferCursor(stack, pos, index) {
    _classCallCheck(this, StackBufferCursor);

    this.stack = stack;
    this.pos = pos;
    this.index = index;
    this.buffer = stack.buffer;
    if (this.index == 0) this.maybeNext();
  }

  _createClass(StackBufferCursor, [{
    key: "maybeNext",
    value: function maybeNext() {
      var next = this.stack.parent;

      if (next != null) {
        this.index = this.stack.bufferBase - next.bufferBase;
        this.stack = next;
        this.buffer = next.buffer;
      }
    }
  }, {
    key: "id",
    get: function get() {
      return this.buffer[this.index - 4];
    }
  }, {
    key: "start",
    get: function get() {
      return this.buffer[this.index - 3];
    }
  }, {
    key: "end",
    get: function get() {
      return this.buffer[this.index - 2];
    }
  }, {
    key: "size",
    get: function get() {
      return this.buffer[this.index - 1];
    }
  }, {
    key: "next",
    value: function next() {
      this.index -= 4;
      this.pos -= 4;
      if (this.index == 0) this.maybeNext();
    }
  }, {
    key: "fork",
    value: function fork() {
      return new StackBufferCursor(this.stack, this.pos, this.index);
    }
  }], [{
    key: "create",
    value: function create(stack) {
      var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : stack.bufferBase + stack.buffer.length;
      return new StackBufferCursor(stack, pos, pos - stack.bufferBase);
    }
  }]);

  return StackBufferCursor;
}(); // See lezer-generator/src/encode.ts for comments about the encoding
// used here


function decodeArray(input) {
  var Type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Uint16Array;
  if (typeof input != "string") return input;
  var array = null;

  for (var pos = 0, out = 0; pos < input.length;) {
    var value = 0;

    for (;;) {
      var next = input.charCodeAt(pos++),
          stop = false;

      if (next == 126
      /* Encode.BigValCode */
      ) {
        value = 65535
        /* Encode.BigVal */
        ;
        break;
      }

      if (next >= 92
      /* Encode.Gap2 */
      ) next--;
      if (next >= 34
      /* Encode.Gap1 */
      ) next--;
      var digit = next - 32
      /* Encode.Start */
      ;

      if (digit >= 46
      /* Encode.Base */
      ) {
        digit -= 46
        /* Encode.Base */
        ;
        stop = true;
      }

      value += digit;
      if (stop) break;
      value *= 46
      /* Encode.Base */
      ;
    }

    if (array) array[out++] = value;else array = new Type(value);
  }

  return array;
}

var CachedToken = /*#__PURE__*/_createClass(function CachedToken() {
  _classCallCheck(this, CachedToken);

  this.start = -1;
  this.value = -1;
  this.end = -1;
  this.extended = -1;
  this.lookAhead = 0;
  this.mask = 0;
  this.context = 0;
});

var nullToken = new CachedToken(); /// [Tokenizers](#lr.ExternalTokenizer) interact with the input
/// through this interface. It presents the input as a stream of
/// characters, tracking lookahead and hiding the complexity of
/// [ranges](#common.Parser.parse^ranges) from tokenizer code.

var InputStream = /*#__PURE__*/function () {
  /// @internal
  function InputStream( /// @internal
  input, /// @internal
  ranges) {
    _classCallCheck(this, InputStream);

    this.input = input;
    this.ranges = ranges; /// @internal

    this.chunk = ""; /// @internal

    this.chunkOff = 0; /// Backup chunk

    this.chunk2 = "";
    this.chunk2Pos = 0; /// The character code of the next code unit in the input, or -1
    /// when the stream is at the end of the input.

    this.next = -1; /// @internal

    this.token = nullToken;
    this.rangeIndex = 0;
    this.pos = this.chunkPos = ranges[0].from;
    this.range = ranges[0];
    this.end = ranges[ranges.length - 1].to;
    this.readNext();
  } /// @internal


  _createClass(InputStream, [{
    key: "resolveOffset",
    value: function resolveOffset(offset, assoc) {
      var range = this.range,
          index = this.rangeIndex;
      var pos = this.pos + offset;

      while (pos < range.from) {
        if (!index) return null;
        var next = this.ranges[--index];
        pos -= range.from - next.to;
        range = next;
      }

      while (assoc < 0 ? pos > range.to : pos >= range.to) {
        if (index == this.ranges.length - 1) return null;
        var _next = this.ranges[++index];
        pos += _next.from - range.to;
        range = _next;
      }

      return pos;
    } /// @internal

  }, {
    key: "clipPos",
    value: function clipPos(pos) {
      if (pos >= this.range.from && pos < this.range.to) return pos;

      var _iterator = _createForOfIteratorHelper(this.ranges),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var range = _step.value;
          if (range.to > pos) return Math.max(pos, range.from);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return this.end;
    } /// Look at a code unit near the stream position. `.peek(0)` equals
    /// `.next`, `.peek(-1)` gives you the previous character, and so
    /// on.
    ///
    /// Note that looking around during tokenizing creates dependencies
    /// on potentially far-away content, which may reduce the
    /// effectiveness incremental parsing—when looking forward—or even
    /// cause invalid reparses when looking backward more than 25 code
    /// units, since the library does not track lookbehind.

  }, {
    key: "peek",
    value: function peek(offset) {
      var idx = this.chunkOff + offset,
          pos,
          result;

      if (idx >= 0 && idx < this.chunk.length) {
        pos = this.pos + offset;
        result = this.chunk.charCodeAt(idx);
      } else {
        var resolved = this.resolveOffset(offset, 1);
        if (resolved == null) return -1;
        pos = resolved;

        if (pos >= this.chunk2Pos && pos < this.chunk2Pos + this.chunk2.length) {
          result = this.chunk2.charCodeAt(pos - this.chunk2Pos);
        } else {
          var i = this.rangeIndex,
              range = this.range;

          while (range.to <= pos) {
            range = this.ranges[++i];
          }

          this.chunk2 = this.input.chunk(this.chunk2Pos = pos);
          if (pos + this.chunk2.length > range.to) this.chunk2 = this.chunk2.slice(0, range.to - pos);
          result = this.chunk2.charCodeAt(0);
        }
      }

      if (pos >= this.token.lookAhead) this.token.lookAhead = pos + 1;
      return result;
    } /// Accept a token. By default, the end of the token is set to the
    /// current stream position, but you can pass an offset (relative to
    /// the stream position) to change that.

  }, {
    key: "acceptToken",
    value: function acceptToken(token) {
      var endOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var end = endOffset ? this.resolveOffset(endOffset, -1) : this.pos;
      if (end == null || end < this.token.start) throw new RangeError("Token end out of bounds");
      this.token.value = token;
      this.token.end = end;
    }
  }, {
    key: "getChunk",
    value: function getChunk() {
      if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
        var chunk = this.chunk,
            chunkPos = this.chunkPos;
        this.chunk = this.chunk2;
        this.chunkPos = this.chunk2Pos;
        this.chunk2 = chunk;
        this.chunk2Pos = chunkPos;
        this.chunkOff = this.pos - this.chunkPos;
      } else {
        this.chunk2 = this.chunk;
        this.chunk2Pos = this.chunkPos;
        var nextChunk = this.input.chunk(this.pos);
        var end = this.pos + nextChunk.length;
        this.chunk = end > this.range.to ? nextChunk.slice(0, this.range.to - this.pos) : nextChunk;
        this.chunkPos = this.pos;
        this.chunkOff = 0;
      }
    }
  }, {
    key: "readNext",
    value: function readNext() {
      if (this.chunkOff >= this.chunk.length) {
        this.getChunk();
        if (this.chunkOff == this.chunk.length) return this.next = -1;
      }

      return this.next = this.chunk.charCodeAt(this.chunkOff);
    } /// Move the stream forward N (defaults to 1) code units. Returns
    /// the new value of [`next`](#lr.InputStream.next).

  }, {
    key: "advance",
    value: function advance() {
      var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.chunkOff += n;

      while (this.pos + n >= this.range.to) {
        if (this.rangeIndex == this.ranges.length - 1) return this.setDone();
        n -= this.range.to - this.pos;
        this.range = this.ranges[++this.rangeIndex];
        this.pos = this.range.from;
      }

      this.pos += n;
      if (this.pos >= this.token.lookAhead) this.token.lookAhead = this.pos + 1;
      return this.readNext();
    }
  }, {
    key: "setDone",
    value: function setDone() {
      this.pos = this.chunkPos = this.end;
      this.range = this.ranges[this.rangeIndex = this.ranges.length - 1];
      this.chunk = "";
      return this.next = -1;
    } /// @internal

  }, {
    key: "reset",
    value: function reset(pos, token) {
      if (token) {
        this.token = token;
        token.start = pos;
        token.lookAhead = pos + 1;
        token.value = token.extended = -1;
      } else {
        this.token = nullToken;
      }

      if (this.pos != pos) {
        this.pos = pos;

        if (pos == this.end) {
          this.setDone();
          return this;
        }

        while (pos < this.range.from) {
          this.range = this.ranges[--this.rangeIndex];
        }

        while (pos >= this.range.to) {
          this.range = this.ranges[++this.rangeIndex];
        }

        if (pos >= this.chunkPos && pos < this.chunkPos + this.chunk.length) {
          this.chunkOff = pos - this.chunkPos;
        } else {
          this.chunk = "";
          this.chunkOff = 0;
        }

        this.readNext();
      }

      return this;
    } /// @internal

  }, {
    key: "read",
    value: function read(from, to) {
      if (from >= this.chunkPos && to <= this.chunkPos + this.chunk.length) return this.chunk.slice(from - this.chunkPos, to - this.chunkPos);
      if (from >= this.chunk2Pos && to <= this.chunk2Pos + this.chunk2.length) return this.chunk2.slice(from - this.chunk2Pos, to - this.chunk2Pos);
      if (from >= this.range.from && to <= this.range.to) return this.input.read(from, to);
      var result = "";

      var _iterator2 = _createForOfIteratorHelper(this.ranges),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var r = _step2.value;
          if (r.from >= to) break;
          if (r.to > from) result += this.input.read(Math.max(r.from, from), Math.min(r.to, to));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return result;
    }
  }]);

  return InputStream;
}(); /// @internal


var TokenGroup = /*#__PURE__*/function () {
  function TokenGroup(data, id) {
    _classCallCheck(this, TokenGroup);

    this.data = data;
    this.id = id;
  }

  _createClass(TokenGroup, [{
    key: "token",
    value: function token(input, stack) {
      var parser = stack.p.parser;
      readToken(this.data, input, stack, this.id, parser.data, parser.tokenPrecTable);
    }
  }]);

  return TokenGroup;
}();

TokenGroup.prototype.contextual = TokenGroup.prototype.fallback = TokenGroup.prototype.extend = false; /// @hide

var LocalTokenGroup = /*#__PURE__*/function () {
  function LocalTokenGroup(data, precTable, elseToken) {
    _classCallCheck(this, LocalTokenGroup);

    this.precTable = precTable;
    this.elseToken = elseToken;
    this.data = typeof data == "string" ? decodeArray(data) : data;
  }

  _createClass(LocalTokenGroup, [{
    key: "token",
    value: function token(input, stack) {
      var start = input.pos,
          cur;

      for (;;) {
        cur = input.pos;
        readToken(this.data, input, stack, 0, this.data, this.precTable);
        if (input.token.value > -1) break;
        if (this.elseToken == null) return;
        if (input.next < 0) break;
        input.advance();
        input.reset(cur + 1, input.token);
      }

      if (cur > start) {
        input.reset(start, input.token);
        input.acceptToken(this.elseToken, cur - start);
      }
    }
  }]);

  return LocalTokenGroup;
}();

LocalTokenGroup.prototype.contextual = TokenGroup.prototype.fallback = TokenGroup.prototype.extend = false; /// `@external tokens` declarations in the grammar should resolve to
/// an instance of this class.

var ExternalTokenizer = /*#__PURE__*/_createClass( /// Create a tokenizer. The first argument is the function that,
/// given an input stream, scans for the types of tokens it
/// recognizes at the stream's position, and calls
/// [`acceptToken`](#lr.InputStream.acceptToken) when it finds
/// one.
function ExternalTokenizer( /// @internal
token) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck(this, ExternalTokenizer);

  this.token = token;
  this.contextual = !!options.contextual;
  this.fallback = !!options.fallback;
  this.extend = !!options.extend;
}); // Tokenizer data is stored a big uint16 array containing, for each
// state:
//
//  - A group bitmask, indicating what token groups are reachable from
//    this state, so that paths that can only lead to tokens not in
//    any of the current groups can be cut off early.
//
//  - The position of the end of the state's sequence of accepting
//    tokens
//
//  - The number of outgoing edges for the state
//
//  - The accepting tokens, as (token id, group mask) pairs
//
//  - The outgoing edges, as (start character, end character, state
//    index) triples, with end character being exclusive
//
// This function interprets that data, running through a stream as
// long as new states with the a matching group mask can be reached,
// and updating `input.token` when it matches a token.


function readToken(data, input, stack, group, precTable, precOffset) {
  var state = 0,
      groupMask = 1 << group,
      dialect = stack.p.parser.dialect;

  scan: for (;;) {
    if ((groupMask & data[state]) == 0) break;
    var accEnd = data[state + 1]; // Check whether this state can lead to a token in the current group
    // Accept tokens in this state, possibly overwriting
    // lower-precedence / shorter tokens

    for (var i = state + 3; i < accEnd; i += 2) {
      if ((data[i + 1] & groupMask) > 0) {
        var term = data[i];

        if (dialect.allows(term) && (input.token.value == -1 || input.token.value == term || overrides(term, input.token.value, precTable, precOffset))) {
          input.acceptToken(term);
          break;
        }
      }
    }

    var next = input.next,
        low = 0,
        high = data[state + 2]; // Special case for EOF

    if (input.next < 0 && high > low && data[accEnd + high * 3 - 3] == 65535
    /* Seq.End */
    && data[accEnd + high * 3 - 3] == 65535
    /* Seq.End */
    ) {
      state = data[accEnd + high * 3 - 1];
      continue scan;
    } // Do a binary search on the state's edges


    for (; low < high;) {
      var mid = low + high >> 1;
      var index = accEnd + mid + (mid << 1);
      var from = data[index],
          to = data[index + 1] || 0x10000;
      if (next < from) high = mid;else if (next >= to) low = mid + 1;else {
        state = data[index + 2];
        input.advance();
        continue scan;
      }
    }

    break;
  }
}

function findOffset(data, start, term) {
  for (var i = start, next; (next = data[i]) != 65535
  /* Seq.End */
  ; i++) {
    if (next == term) return i - start;
  }

  return -1;
}

function overrides(token, prev, tableData, tableOffset) {
  var iPrev = findOffset(tableData, tableOffset, prev);
  return iPrev < 0 || findOffset(tableData, tableOffset, token) < iPrev;
} // Environment variable used to control console output


var verbose = typeof process != "undefined" && process.env && /\bparse\b/.test(process.env.LOG);
var stackIDs = null;
var Safety;

(function (Safety) {
  Safety[Safety["Margin"] = 25] = "Margin";
})(Safety || (Safety = {}));

function cutAt(tree, pos, side) {
  var cursor = tree.cursor(IterMode.IncludeAnonymous);
  cursor.moveTo(pos);

  for (;;) {
    if (!(side < 0 ? cursor.childBefore(pos) : cursor.childAfter(pos))) for (;;) {
      if ((side < 0 ? cursor.to < pos : cursor.from > pos) && !cursor.type.isError) return side < 0 ? Math.max(0, Math.min(cursor.to - 1, pos - 25
      /* Safety.Margin */
      )) : Math.min(tree.length, Math.max(cursor.from + 1, pos + 25
      /* Safety.Margin */
      ));
      if (side < 0 ? cursor.prevSibling() : cursor.nextSibling()) break;
      if (!cursor.parent()) return side < 0 ? 0 : tree.length;
    }
  }
}

var FragmentCursor = /*#__PURE__*/function () {
  function FragmentCursor(fragments, nodeSet) {
    _classCallCheck(this, FragmentCursor);

    this.fragments = fragments;
    this.nodeSet = nodeSet;
    this.i = 0;
    this.fragment = null;
    this.safeFrom = -1;
    this.safeTo = -1;
    this.trees = [];
    this.start = [];
    this.index = [];
    this.nextFragment();
  }

  _createClass(FragmentCursor, [{
    key: "nextFragment",
    value: function nextFragment() {
      var fr = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];

      if (fr) {
        this.safeFrom = fr.openStart ? cutAt(fr.tree, fr.from + fr.offset, 1) - fr.offset : fr.from;
        this.safeTo = fr.openEnd ? cutAt(fr.tree, fr.to + fr.offset, -1) - fr.offset : fr.to;

        while (this.trees.length) {
          this.trees.pop();
          this.start.pop();
          this.index.pop();
        }

        this.trees.push(fr.tree);
        this.start.push(-fr.offset);
        this.index.push(0);
        this.nextStart = this.safeFrom;
      } else {
        this.nextStart = 1e9;
      }
    } // `pos` must be >= any previously given `pos` for this cursor

  }, {
    key: "nodeAt",
    value: function nodeAt(pos) {
      if (pos < this.nextStart) return null;

      while (this.fragment && this.safeTo <= pos) {
        this.nextFragment();
      }

      if (!this.fragment) return null;

      for (;;) {
        var last = this.trees.length - 1;

        if (last < 0) {
          // End of tree
          this.nextFragment();
          return null;
        }

        var top = this.trees[last],
            index = this.index[last];

        if (index == top.children.length) {
          this.trees.pop();
          this.start.pop();
          this.index.pop();
          continue;
        }

        var next = top.children[index];
        var start = this.start[last] + top.positions[index];

        if (start > pos) {
          this.nextStart = start;
          return null;
        }

        if (next instanceof Tree) {
          if (start == pos) {
            if (start < this.safeFrom) return null;
            var end = start + next.length;

            if (end <= this.safeTo) {
              var lookAhead = next.prop(NodeProp.lookAhead);
              if (!lookAhead || end + lookAhead < this.fragment.to) return next;
            }
          }

          this.index[last]++;

          if (start + next.length >= Math.max(this.safeFrom, pos)) {
            // Enter this node
            this.trees.push(next);
            this.start.push(start);
            this.index.push(0);
          }
        } else {
          this.index[last]++;
          this.nextStart = start + next.length;
        }
      }
    }
  }]);

  return FragmentCursor;
}();

var TokenCache = /*#__PURE__*/function () {
  function TokenCache(parser, stream) {
    _classCallCheck(this, TokenCache);

    this.stream = stream;
    this.tokens = [];
    this.mainToken = null;
    this.actions = [];
    this.tokens = parser.tokenizers.map(function (_) {
      return new CachedToken();
    });
  }

  _createClass(TokenCache, [{
    key: "getActions",
    value: function getActions(stack) {
      var actionIndex = 0;
      var main = null;
      var parser = stack.p.parser,
          tokenizers = parser.tokenizers;
      var mask = parser.stateSlot(stack.state, 3
      /* ParseState.TokenizerMask */
      );
      var context = stack.curContext ? stack.curContext.hash : 0;
      var lookAhead = 0;

      for (var i = 0; i < tokenizers.length; i++) {
        if ((1 << i & mask) == 0) continue;
        var tokenizer = tokenizers[i],
            token = this.tokens[i];
        if (main && !tokenizer.fallback) continue;

        if (tokenizer.contextual || token.start != stack.pos || token.mask != mask || token.context != context) {
          this.updateCachedToken(token, tokenizer, stack);
          token.mask = mask;
          token.context = context;
        }

        if (token.lookAhead > token.end + 25
        /* Safety.Margin */
        ) lookAhead = Math.max(token.lookAhead, lookAhead);

        if (token.value != 0
        /* Term.Err */
        ) {
          var startIndex = actionIndex;
          if (token.extended > -1) actionIndex = this.addActions(stack, token.extended, token.end, actionIndex);
          actionIndex = this.addActions(stack, token.value, token.end, actionIndex);

          if (!tokenizer.extend) {
            main = token;
            if (actionIndex > startIndex) break;
          }
        }
      }

      while (this.actions.length > actionIndex) {
        this.actions.pop();
      }

      if (lookAhead) stack.setLookAhead(lookAhead);

      if (!main && stack.pos == this.stream.end) {
        main = new CachedToken();
        main.value = stack.p.parser.eofTerm;
        main.start = main.end = stack.pos;
        actionIndex = this.addActions(stack, main.value, main.end, actionIndex);
      }

      this.mainToken = main;
      return this.actions;
    }
  }, {
    key: "getMainToken",
    value: function getMainToken(stack) {
      if (this.mainToken) return this.mainToken;
      var main = new CachedToken(),
          pos = stack.pos,
          p = stack.p;
      main.start = pos;
      main.end = Math.min(pos + 1, p.stream.end);
      main.value = pos == p.stream.end ? p.parser.eofTerm : 0
      /* Term.Err */
      ;
      return main;
    }
  }, {
    key: "updateCachedToken",
    value: function updateCachedToken(token, tokenizer, stack) {
      var start = this.stream.clipPos(stack.pos);
      tokenizer.token(this.stream.reset(start, token), stack);

      if (token.value > -1) {
        var parser = stack.p.parser;

        for (var i = 0; i < parser.specialized.length; i++) {
          if (parser.specialized[i] == token.value) {
            var result = parser.specializers[i](this.stream.read(token.start, token.end), stack);

            if (result >= 0 && stack.p.parser.dialect.allows(result >> 1)) {
              if ((result & 1) == 0
              /* Specialize.Specialize */
              ) token.value = result >> 1;else token.extended = result >> 1;
              break;
            }
          }
        }
      } else {
        token.value = 0
        /* Term.Err */
        ;
        token.end = this.stream.clipPos(start + 1);
      }
    }
  }, {
    key: "putAction",
    value: function putAction(action, token, end, index) {
      // Don't add duplicate actions
      for (var i = 0; i < index; i += 3) {
        if (this.actions[i] == action) return index;
      }

      this.actions[index++] = action;
      this.actions[index++] = token;
      this.actions[index++] = end;
      return index;
    }
  }, {
    key: "addActions",
    value: function addActions(stack, token, end, index) {
      var state = stack.state,
          parser = stack.p.parser,
          data = parser.data;

      for (var set = 0; set < 2; set++) {
        for (var i = parser.stateSlot(state, set ? 2
        /* ParseState.Skip */
        : 1
        /* ParseState.Actions */
        );; i += 3) {
          if (data[i] == 65535
          /* Seq.End */
          ) {
            if (data[i + 1] == 1
            /* Seq.Next */
            ) {
              i = pair(data, i + 2);
            } else {
              if (index == 0 && data[i + 1] == 2
              /* Seq.Other */
              ) index = this.putAction(pair(data, i + 2), token, end, index);
              break;
            }
          }

          if (data[i] == token) index = this.putAction(pair(data, i + 1), token, end, index);
        }
      }

      return index;
    }
  }]);

  return TokenCache;
}();

var Rec;

(function (Rec) {
  Rec[Rec["Distance"] = 5] = "Distance";
  Rec[Rec["MaxRemainingPerStep"] = 3] = "MaxRemainingPerStep"; // When two stacks have been running independently long enough to
  // add this many elements to their buffers, prune one.

  Rec[Rec["MinBufferLengthPrune"] = 500] = "MinBufferLengthPrune";
  Rec[Rec["ForceReduceLimit"] = 10] = "ForceReduceLimit"; // Once a stack reaches this depth (in .stack.length) force-reduce
  // it back to CutTo to avoid creating trees that overflow the stack
  // on recursive traversal.

  Rec[Rec["CutDepth"] = 15000] = "CutDepth";
  Rec[Rec["CutTo"] = 9000] = "CutTo";
  Rec[Rec["MaxLeftAssociativeReductionCount"] = 300] = "MaxLeftAssociativeReductionCount"; // The maximum number of non-recovering stacks to explore (to avoid
  // getting bogged down with exponentially multiplying stacks in
  // ambiguous content)

  Rec[Rec["MaxStackCount"] = 12] = "MaxStackCount";
})(Rec || (Rec = {}));

var Parse = /*#__PURE__*/function () {
  function Parse(parser, input, fragments, ranges) {
    _classCallCheck(this, Parse);

    this.parser = parser;
    this.input = input;
    this.ranges = ranges;
    this.recovering = 0;
    this.nextStackID = 0x2654; // ♔, ♕, ♖, ♗, ♘, ♙, ♠, ♡, ♢, ♣, ♤, ♥, ♦, ♧

    this.minStackPos = 0;
    this.reused = [];
    this.stoppedAt = null;
    this.lastBigReductionStart = -1;
    this.lastBigReductionSize = 0;
    this.bigReductionCount = 0;
    this.stream = new InputStream(input, ranges);
    this.tokens = new TokenCache(parser, this.stream);
    this.topTerm = parser.top[1];
    var from = ranges[0].from;
    this.stacks = [Stack.start(this, parser.top[0], from)];
    this.fragments = fragments.length && this.stream.end - from > parser.bufferLength * 4 ? new FragmentCursor(fragments, parser.nodeSet) : null;
  }

  _createClass(Parse, [{
    key: "parsedPos",
    get: function get() {
      return this.minStackPos;
    } // Move the parser forward. This will process all parse stacks at
    // `this.pos` and try to advance them to a further position. If no
    // stack for such a position is found, it'll start error-recovery.
    //
    // When the parse is finished, this will return a syntax tree. When
    // not, it returns `null`.

  }, {
    key: "advance",
    value: function advance() {
      var stacks = this.stacks,
          pos = this.minStackPos; // This will hold stacks beyond `pos`.

      var newStacks = this.stacks = [];
      var stopped, stoppedTokens; // If a large amount of reductions happened with the same start
      // position, force the stack out of that production in order to
      // avoid creating a tree too deep to recurse through.
      // (This is an ugly kludge, because unfortunately there is no
      // straightforward, cheap way to check for this happening, due to
      // the history of reductions only being available in an
      // expensive-to-access format in the stack buffers.)

      if (this.bigReductionCount > 300
      /* Rec.MaxLeftAssociativeReductionCount */
      && stacks.length == 1) {
        var _stacks = _slicedToArray(stacks, 1),
            s = _stacks[0];

        while (s.forceReduce() && s.stack.length && s.stack[s.stack.length - 2] >= this.lastBigReductionStart) {}

        this.bigReductionCount = this.lastBigReductionSize = 0;
      } // Keep advancing any stacks at `pos` until they either move
      // forward or can't be advanced. Gather stacks that can't be
      // advanced further in `stopped`.


      for (var i = 0; i < stacks.length; i++) {
        var stack = stacks[i];

        for (;;) {
          this.tokens.mainToken = null;

          if (stack.pos > pos) {
            newStacks.push(stack);
          } else if (this.advanceStack(stack, newStacks, stacks)) {
            continue;
          } else {
            if (!stopped) {
              stopped = [];
              stoppedTokens = [];
            }

            stopped.push(stack);
            var tok = this.tokens.getMainToken(stack);
            stoppedTokens.push(tok.value, tok.end);
          }

          break;
        }
      }

      if (!newStacks.length) {
        var finished = stopped && findFinished(stopped);
        if (finished) return this.stackToTree(finished);

        if (this.parser.strict) {
          if (verbose && stopped) console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none"));
          throw new SyntaxError("No parse at " + pos);
        }

        if (!this.recovering) this.recovering = 5
        /* Rec.Distance */
        ;
      }

      if (this.recovering && stopped) {
        var _finished = this.stoppedAt != null && stopped[0].pos > this.stoppedAt ? stopped[0] : this.runRecovery(stopped, stoppedTokens, newStacks);

        if (_finished) return this.stackToTree(_finished.forceAll());
      }

      if (this.recovering) {
        var maxRemaining = this.recovering == 1 ? 1 : this.recovering * 3
        /* Rec.MaxRemainingPerStep */
        ;

        if (newStacks.length > maxRemaining) {
          newStacks.sort(function (a, b) {
            return b.score - a.score;
          });

          while (newStacks.length > maxRemaining) {
            newStacks.pop();
          }
        }

        if (newStacks.some(function (s) {
          return s.reducePos > pos;
        })) this.recovering--;
      } else if (newStacks.length > 1) {
        // Prune stacks that are in the same state, or that have been
        // running without splitting for a while, to avoid getting stuck
        // with multiple successful stacks running endlessly on.
        outer: for (var _i3 = 0; _i3 < newStacks.length - 1; _i3++) {
          var _stack = newStacks[_i3];

          for (var j = _i3 + 1; j < newStacks.length; j++) {
            var other = newStacks[j];

            if (_stack.sameState(other) || _stack.buffer.length > 500
            /* Rec.MinBufferLengthPrune */
            && other.buffer.length > 500
            /* Rec.MinBufferLengthPrune */
            ) {
              if ((_stack.score - other.score || _stack.buffer.length - other.buffer.length) > 0) {
                newStacks.splice(j--, 1);
              } else {
                newStacks.splice(_i3--, 1);
                continue outer;
              }
            }
          }
        }

        if (newStacks.length > 12
        /* Rec.MaxStackCount */
        ) newStacks.splice(12
        /* Rec.MaxStackCount */
        , newStacks.length - 12
        /* Rec.MaxStackCount */
        );
      }

      this.minStackPos = newStacks[0].pos;

      for (var _i4 = 1; _i4 < newStacks.length; _i4++) {
        if (newStacks[_i4].pos < this.minStackPos) this.minStackPos = newStacks[_i4].pos;
      }

      return null;
    }
  }, {
    key: "stopAt",
    value: function stopAt(pos) {
      if (this.stoppedAt != null && this.stoppedAt < pos) throw new RangeError("Can't move stoppedAt forward");
      this.stoppedAt = pos;
    } // Returns an updated version of the given stack, or null if the
    // stack can't advance normally. When `split` and `stacks` are
    // given, stacks split off by ambiguous operations will be pushed to
    // `split`, or added to `stacks` if they move `pos` forward.

  }, {
    key: "advanceStack",
    value: function advanceStack(stack, stacks, split) {
      var start = stack.pos,
          parser = this.parser;
      var base = verbose ? this.stackID(stack) + " -> " : "";
      if (this.stoppedAt != null && start > this.stoppedAt) return stack.forceReduce() ? stack : null;

      if (this.fragments) {
        var strictCx = stack.curContext && stack.curContext.tracker.strict,
            cxHash = strictCx ? stack.curContext.hash : 0;

        for (var cached = this.fragments.nodeAt(start); cached;) {
          var match = this.parser.nodeSet.types[cached.type.id] == cached.type ? parser.getGoto(stack.state, cached.type.id) : -1;

          if (match > -1 && cached.length && (!strictCx || (cached.prop(NodeProp.contextHash) || 0) == cxHash)) {
            stack.useNode(cached, match);
            if (verbose) console.log(base + this.stackID(stack) + " (via reuse of ".concat(parser.getName(cached.type.id), ")"));
            return true;
          }

          if (!(cached instanceof Tree) || cached.children.length == 0 || cached.positions[0] > 0) break;
          var inner = cached.children[0];
          if (inner instanceof Tree && cached.positions[0] == 0) cached = inner;else break;
        }
      }

      var defaultReduce = parser.stateSlot(stack.state, 4
      /* ParseState.DefaultReduce */
      );

      if (defaultReduce > 0) {
        stack.reduce(defaultReduce);
        if (verbose) console.log(base + this.stackID(stack) + " (via always-reduce ".concat(parser.getName(defaultReduce & 65535
        /* Action.ValueMask */
        ), ")"));
        return true;
      }

      if (stack.stack.length >= 15000
      /* Rec.CutDepth */
      ) {
        while (stack.stack.length > 9000
        /* Rec.CutTo */
        && stack.forceReduce()) {}
      }

      var actions = this.tokens.getActions(stack);

      for (var i = 0; i < actions.length;) {
        var action = actions[i++],
            term = actions[i++],
            end = actions[i++];
        var last = i == actions.length || !split;
        var localStack = last ? stack : stack.split();
        localStack.apply(action, term, end);
        if (verbose) console.log(base + this.stackID(localStack) + " (via ".concat((action & 65536
        /* Action.ReduceFlag */
        ) == 0 ? "shift" : "reduce of ".concat(parser.getName(action & 65535
        /* Action.ValueMask */
        )), " for ").concat(parser.getName(term), " @ ").concat(start).concat(localStack == stack ? "" : ", split", ")"));
        if (last) return true;else if (localStack.pos > start) stacks.push(localStack);else split.push(localStack);
      }

      return false;
    } // Advance a given stack forward as far as it will go. Returns the
    // (possibly updated) stack if it got stuck, or null if it moved
    // forward and was given to `pushStackDedup`.

  }, {
    key: "advanceFully",
    value: function advanceFully(stack, newStacks) {
      var pos = stack.pos;

      for (;;) {
        if (!this.advanceStack(stack, null, null)) return false;

        if (stack.pos > pos) {
          pushStackDedup(stack, newStacks);
          return true;
        }
      }
    }
  }, {
    key: "runRecovery",
    value: function runRecovery(stacks, tokens, newStacks) {
      var finished = null,
          restarted = false;

      for (var i = 0; i < stacks.length; i++) {
        var stack = stacks[i],
            token = tokens[i << 1],
            tokenEnd = tokens[(i << 1) + 1];
        var base = verbose ? this.stackID(stack) + " -> " : "";

        if (stack.deadEnd) {
          if (restarted) continue;
          restarted = true;
          stack.restart();
          if (verbose) console.log(base + this.stackID(stack) + " (restarted)");
          var done = this.advanceFully(stack, newStacks);
          if (done) continue;
        }

        var force = stack.split(),
            forceBase = base;

        for (var j = 0; force.forceReduce() && j < 10
        /* Rec.ForceReduceLimit */
        ; j++) {
          if (verbose) console.log(forceBase + this.stackID(force) + " (via force-reduce)");

          var _done = this.advanceFully(force, newStacks);

          if (_done) break;
          if (verbose) forceBase = this.stackID(force) + " -> ";
        }

        var _iterator3 = _createForOfIteratorHelper(stack.recoverByInsert(token)),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var insert = _step3.value;
            if (verbose) console.log(base + this.stackID(insert) + " (via recover-insert)");
            this.advanceFully(insert, newStacks);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        if (this.stream.end > stack.pos) {
          if (tokenEnd == stack.pos) {
            tokenEnd++;
            token = 0
            /* Term.Err */
            ;
          }

          stack.recoverByDelete(token, tokenEnd);
          if (verbose) console.log(base + this.stackID(stack) + " (via recover-delete ".concat(this.parser.getName(token), ")"));
          pushStackDedup(stack, newStacks);
        } else if (!finished || finished.score < stack.score) {
          finished = stack;
        }
      }

      return finished;
    } // Convert the stack's buffer to a syntax tree.

  }, {
    key: "stackToTree",
    value: function stackToTree(stack) {
      stack.close();
      return Tree.build({
        buffer: StackBufferCursor.create(stack),
        nodeSet: this.parser.nodeSet,
        topID: this.topTerm,
        maxBufferLength: this.parser.bufferLength,
        reused: this.reused,
        start: this.ranges[0].from,
        length: stack.pos - this.ranges[0].from,
        minRepeatType: this.parser.minRepeatTerm
      });
    }
  }, {
    key: "stackID",
    value: function stackID(stack) {
      var id = (stackIDs || (stackIDs = new WeakMap())).get(stack);
      if (!id) stackIDs.set(stack, id = String.fromCodePoint(this.nextStackID++));
      return id + stack;
    }
  }]);

  return Parse;
}();

function pushStackDedup(stack, newStacks) {
  for (var i = 0; i < newStacks.length; i++) {
    var other = newStacks[i];

    if (other.pos == stack.pos && other.sameState(stack)) {
      if (newStacks[i].score < stack.score) newStacks[i] = stack;
      return;
    }
  }

  newStacks.push(stack);
}

var Dialect = /*#__PURE__*/function () {
  function Dialect(source, flags, disabled) {
    _classCallCheck(this, Dialect);

    this.source = source;
    this.flags = flags;
    this.disabled = disabled;
  }

  _createClass(Dialect, [{
    key: "allows",
    value: function allows(term) {
      return !this.disabled || this.disabled[term] == 0;
    }
  }]);

  return Dialect;
}();

var id = function id(x) {
  return x;
}; /// Context trackers are used to track stateful context (such as
/// indentation in the Python grammar, or parent elements in the XML
/// grammar) needed by external tokenizers. You declare them in a
/// grammar file as `@context exportName from "module"`.
///
/// Context values should be immutable, and can be updated (replaced)
/// on shift or reduce actions.
///
/// The export used in a `@context` declaration should be of this
/// type.


var ContextTracker = /*#__PURE__*/_createClass( /// Define a context tracker.
function ContextTracker(spec) {
  _classCallCheck(this, ContextTracker);

  this.start = spec.start;
  this.shift = spec.shift || id;
  this.reduce = spec.reduce || id;
  this.reuse = spec.reuse || id;

  this.hash = spec.hash || function () {
    return 0;
  };

  this.strict = spec.strict !== false;
}); /// Holds the parse tables for a given grammar, as generated by
/// `lezer-generator`, and provides [methods](#common.Parser) to parse
/// content with.


var LRParser = /*#__PURE__*/function (_Parser) {
  _inherits(LRParser, _Parser);

  var _super = _createSuper(LRParser);

  /// @internal
  function LRParser(spec) {
    var _this$nodeSet;

    var _this;

    _classCallCheck(this, LRParser);

    _this = _super.call(this); /// @internal

    _this.wrappers = [];
    if (spec.version != 14
    /* File.Version */
    ) throw new RangeError("Parser version (".concat(spec.version, ") doesn't match runtime version (", 14
    /* File.Version */
    , ")"));
    var nodeNames = spec.nodeNames.split(" ");
    _this.minRepeatTerm = nodeNames.length;

    for (var i = 0; i < spec.repeatNodeCount; i++) {
      nodeNames.push("");
    }

    var topTerms = Object.keys(spec.topRules).map(function (r) {
      return spec.topRules[r][1];
    });
    var nodeProps = [];

    for (var _i5 = 0; _i5 < nodeNames.length; _i5++) {
      nodeProps.push([]);
    }

    function setProp(nodeID, prop, value) {
      nodeProps[nodeID].push([prop, prop.deserialize(String(value))]);
    }

    if (spec.nodeProps) {
      var _iterator4 = _createForOfIteratorHelper(spec.nodeProps),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var propSpec = _step4.value;
          var prop = propSpec[0];
          if (typeof prop == "string") prop = NodeProp[prop];

          for (var _i6 = 1; _i6 < propSpec.length;) {
            var next = propSpec[_i6++];

            if (next >= 0) {
              setProp(next, prop, propSpec[_i6++]);
            } else {
              var value = propSpec[_i6 + -next];

              for (var j = -next; j > 0; j--) {
                setProp(propSpec[_i6++], prop, value);
              }

              _i6++;
            }
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }

    _this.nodeSet = new NodeSet(nodeNames.map(function (name, i) {
      return NodeType.define({
        name: i >= _this.minRepeatTerm ? undefined : name,
        id: i,
        props: nodeProps[i],
        top: topTerms.indexOf(i) > -1,
        error: i == 0,
        skipped: spec.skippedNodes && spec.skippedNodes.indexOf(i) > -1
      });
    }));
    if (spec.propSources) _this.nodeSet = (_this$nodeSet = _this.nodeSet).extend.apply(_this$nodeSet, _toConsumableArray(spec.propSources));
    _this.strict = false;
    _this.bufferLength = DefaultBufferLength;
    var tokenArray = decodeArray(spec.tokenData);
    _this.context = spec.context;
    _this.specializerSpecs = spec.specialized || [];
    _this.specialized = new Uint16Array(_this.specializerSpecs.length);

    for (var _i7 = 0; _i7 < _this.specializerSpecs.length; _i7++) {
      _this.specialized[_i7] = _this.specializerSpecs[_i7].term;
    }

    _this.specializers = _this.specializerSpecs.map(getSpecializer);
    _this.states = decodeArray(spec.states, Uint32Array);
    _this.data = decodeArray(spec.stateData);
    _this.goto = decodeArray(spec.goto);
    _this.maxTerm = spec.maxTerm;
    _this.tokenizers = spec.tokenizers.map(function (value) {
      return typeof value == "number" ? new TokenGroup(tokenArray, value) : value;
    });
    _this.topRules = spec.topRules;
    _this.dialects = spec.dialects || {};
    _this.dynamicPrecedences = spec.dynamicPrecedences || null;
    _this.tokenPrecTable = spec.tokenPrec;
    _this.termNames = spec.termNames || null;
    _this.maxNode = _this.nodeSet.types.length - 1;
    _this.dialect = _this.parseDialect();
    _this.top = _this.topRules[Object.keys(_this.topRules)[0]];
    return _this;
  }

  _createClass(LRParser, [{
    key: "createParse",
    value: function createParse(input, fragments, ranges) {
      var parse = new Parse(this, input, fragments, ranges);

      var _iterator5 = _createForOfIteratorHelper(this.wrappers),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var w = _step5.value;
          parse = w(parse, input, fragments, ranges);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return parse;
    } /// Get a goto table entry @internal

  }, {
    key: "getGoto",
    value: function getGoto(state, term) {
      var loose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var table = this.goto;
      if (term >= table[0]) return -1;

      for (var pos = table[term + 1];;) {
        var groupTag = table[pos++],
            last = groupTag & 1;
        var target = table[pos++];
        if (last && loose) return target;

        for (var end = pos + (groupTag >> 1); pos < end; pos++) {
          if (table[pos] == state) return target;
        }

        if (last) return -1;
      }
    } /// Check if this state has an action for a given terminal @internal

  }, {
    key: "hasAction",
    value: function hasAction(state, terminal) {
      var data = this.data;

      for (var set = 0; set < 2; set++) {
        for (var i = this.stateSlot(state, set ? 2
        /* ParseState.Skip */
        : 1
        /* ParseState.Actions */
        ), next;; i += 3) {
          if ((next = data[i]) == 65535
          /* Seq.End */
          ) {
            if (data[i + 1] == 1
            /* Seq.Next */
            ) next = data[i = pair(data, i + 2)];else if (data[i + 1] == 2
            /* Seq.Other */
            ) return pair(data, i + 2);else break;
          }

          if (next == terminal || next == 0
          /* Term.Err */
          ) return pair(data, i + 1);
        }
      }

      return 0;
    } /// @internal

  }, {
    key: "stateSlot",
    value: function stateSlot(state, slot) {
      return this.states[state * 6
      /* ParseState.Size */
      + slot];
    } /// @internal

  }, {
    key: "stateFlag",
    value: function stateFlag(state, flag) {
      return (this.stateSlot(state, 0
      /* ParseState.Flags */
      ) & flag) > 0;
    } /// @internal

  }, {
    key: "validAction",
    value: function validAction(state, action) {
      if (action == this.stateSlot(state, 4
      /* ParseState.DefaultReduce */
      )) return true;

      for (var i = this.stateSlot(state, 1
      /* ParseState.Actions */
      );; i += 3) {
        if (this.data[i] == 65535
        /* Seq.End */
        ) {
          if (this.data[i + 1] == 1
          /* Seq.Next */
          ) i = pair(this.data, i + 2);else return false;
        }

        if (action == pair(this.data, i + 1)) return true;
      }
    } /// Get the states that can follow this one through shift actions or
    /// goto jumps. @internal

  }, {
    key: "nextStates",
    value: function nextStates(state) {
      var _this2 = this;

      var result = [];

      for (var i = this.stateSlot(state, 1
      /* ParseState.Actions */
      );; i += 3) {
        if (this.data[i] == 65535
        /* Seq.End */
        ) {
          if (this.data[i + 1] == 1
          /* Seq.Next */
          ) i = pair(this.data, i + 2);else break;
        }

        if ((this.data[i + 2] & 65536
        /* Action.ReduceFlag */
        >> 16) == 0) {
          (function () {
            var value = _this2.data[i + 1];
            if (!result.some(function (v, i) {
              return i & 1 && v == value;
            })) result.push(_this2.data[i], value);
          })();
        }
      }

      return result;
    } /// Configure the parser. Returns a new parser instance that has the
    /// given settings modified. Settings not provided in `config` are
    /// kept from the original parser.

  }, {
    key: "configure",
    value: function configure(config) {
      var _this$nodeSet2;

      // Hideous reflection-based kludge to make it easy to create a
      // slightly modified copy of a parser.
      var copy = Object.assign(Object.create(LRParser.prototype), this);
      if (config.props) copy.nodeSet = (_this$nodeSet2 = this.nodeSet).extend.apply(_this$nodeSet2, _toConsumableArray(config.props));

      if (config.top) {
        var info = this.topRules[config.top];
        if (!info) throw new RangeError("Invalid top rule name ".concat(config.top));
        copy.top = info;
      }

      if (config.tokenizers) copy.tokenizers = this.tokenizers.map(function (t) {
        var found = config.tokenizers.find(function (r) {
          return r.from == t;
        });
        return found ? found.to : t;
      });

      if (config.specializers) {
        copy.specializers = this.specializers.slice();
        copy.specializerSpecs = this.specializerSpecs.map(function (s, i) {
          var found = config.specializers.find(function (r) {
            return r.from == s.external;
          });
          if (!found) return s;
          var spec = Object.assign(Object.assign({}, s), {
            external: found.to
          });
          copy.specializers[i] = getSpecializer(spec);
          return spec;
        });
      }

      if (config.contextTracker) copy.context = config.contextTracker;
      if (config.dialect) copy.dialect = this.parseDialect(config.dialect);
      if (config.strict != null) copy.strict = config.strict;
      if (config.wrap) copy.wrappers = copy.wrappers.concat(config.wrap);
      if (config.bufferLength != null) copy.bufferLength = config.bufferLength;
      return copy;
    } /// Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
    /// are registered for this parser.

  }, {
    key: "hasWrappers",
    value: function hasWrappers() {
      return this.wrappers.length > 0;
    } /// Returns the name associated with a given term. This will only
    /// work for all terms when the parser was generated with the
    /// `--names` option. By default, only the names of tagged terms are
    /// stored.

  }, {
    key: "getName",
    value: function getName(term) {
      return this.termNames ? this.termNames[term] : String(term <= this.maxNode && this.nodeSet.types[term].name || term);
    } /// The eof term id is always allocated directly after the node
    /// types. @internal

  }, {
    key: "eofTerm",
    get: function get() {
      return this.maxNode + 1;
    } /// The type of top node produced by the parser.

  }, {
    key: "topNode",
    get: function get() {
      return this.nodeSet.types[this.top[1]];
    } /// @internal

  }, {
    key: "dynamicPrecedence",
    value: function dynamicPrecedence(term) {
      var prec = this.dynamicPrecedences;
      return prec == null ? 0 : prec[term] || 0;
    } /// @internal

  }, {
    key: "parseDialect",
    value: function parseDialect(dialect) {
      var values = Object.keys(this.dialects),
          flags = values.map(function () {
        return false;
      });

      if (dialect) {
        var _iterator6 = _createForOfIteratorHelper(dialect.split(" ")),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var part = _step6.value;

            var _id = values.indexOf(part);

            if (_id >= 0) flags[_id] = true;
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }

      var disabled = null;

      for (var i = 0; i < values.length; i++) {
        if (!flags[i]) {
          for (var j = this.dialects[values[i]], _id2; (_id2 = this.data[j++]) != 65535
          /* Seq.End */
          ;) {
            (disabled || (disabled = new Uint8Array(this.maxTerm + 1)))[_id2] = 1;
          }
        }
      }

      return new Dialect(dialect, flags, disabled);
    } /// Used by the output of the parser generator. Not available to
    /// user code. @hide

  }], [{
    key: "deserialize",
    value: function deserialize(spec) {
      return new LRParser(spec);
    }
  }]);

  return LRParser;
}(Parser);

function pair(data, off) {
  return data[off] | data[off + 1] << 16;
}

function findFinished(stacks) {
  var best = null;

  var _iterator7 = _createForOfIteratorHelper(stacks),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var stack = _step7.value;
      var stopped = stack.p.stoppedAt;
      if ((stack.pos == stack.p.stream.end || stopped != null && stack.pos > stopped) && stack.p.parser.stateFlag(stack.state, 2
      /* StateFlag.Accepting */
      ) && (!best || best.score < stack.score)) best = stack;
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  return best;
}

function getSpecializer(spec) {
  if (spec.external) {
    var mask = spec.extend ? 1
    /* Specialize.Extend */
    : 0
    /* Specialize.Specialize */
    ;
    return function (value, stack) {
      return spec.external(value, stack) << 1 | mask;
    };
  }

  return spec.get;
}

export { ContextTracker, ExternalTokenizer, InputStream, LRParser, LocalTokenGroup, Stack };